(() => {
  // Il configuratore della pagina prodotto e quello della pagina dedicata condividono questo asset.
  // Non interrompere l'esecuzione se lo script parte prima che la sezione sia nel DOM:
  // la pagina dedicata deve comunque poter registrare DRGStartConfigurator.
  const root = document.querySelector('.drg-config');

  function startConfigurator(root, runtimeProduct) {
    const dataEl = root.querySelector('.drg-accessories-json');
  if (!dataEl) return false;
  let accessories = [];
  try { accessories = JSON.parse(dataEl.textContent.trim() || '[]'); } catch(e) { console.error('DRG data error', e); return; }

    const productVariantId = Number((runtimeProduct && runtimeProduct.variantId) || root.dataset.productId);
    const productTitle = (runtimeProduct && runtimeProduct.title) || root.dataset.productTitle || '';
  if (/pronta\s+consegna/i.test(String(productTitle))) { root.hidden = true; return; }
    const runtimeBasePrice = runtimeProduct && Number(runtimeProduct.price);
    const runtimeImage = (runtimeProduct && runtimeProduct.image) || '';
    const moneyFmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

  const modelText = productTitle.toLowerCase();
  const model =
    /old[\s-]*style|montanari/.test(modelText) ? 'oldstyle' :
    /bartop/.test(modelText) ? 'bartop' :
    /wallcab/.test(modelText) ? 'wallcab' :
    /plancia|planche/.test(modelText) ? 'planche' : 'cabinato';

  const isSlimModel = /\bslim\b/i.test(productTitle);
  const isSlim4 = /\bslim\s*4\s*player\b/i.test(productTitle);

  const state = {
    selected: new Map(),
    prices: new Map(),
    products: new Map(),
    graphic: '',
    quantities: new Map(),
    lightgunColors: new Map(),
    basePrice: 0,
    busy: false
  };

  const compatibility = item => {
    const h = item.h, g = item.g;
    if (g === 'controls' || g === 'arcade' || g === 'shooter' || g === 'hardware' || g === 'audio') return true;
    if (g === 'hardware_disk') return true;
    if (g === 'dmd') return model === 'cabinato' || model === 'oldstyle' || model === 'bartop' ? model === 'cabinato' || model === 'oldstyle' : false;
    if (g === 'extra') return model === 'cabinato' || model === 'oldstyle';
    if (g === 'video') {
      // Gli Slim hanno già il 27" incluso di serie: non mostrarlo come optional.
      if (h === 'monitor-27-hd-gaming') return !isSlimModel && model !== 'planche';
      if (h === 'monitor-32-hd-gaming') return !isSlim4 && (model === 'cabinato' || model === 'oldstyle');
      // Il 40" è disponibile esclusivamente per lo Slim 4 Player.
      if (h === 'monitor-40-full-hd-gaming') return isSlim4;
      return false;
    }
    if (g === 'driving' || g === 'driving_extra' || g === 'steeringwheel') return model === 'cabinato' || model === 'oldstyle';
    return true;
  };

  // Explicitly keep the DMD rule: all cabinati, including Old Style Montanari; never Bartop/Wallcab/Planche.
  const isCompatible = item => {
    if (item.g === 'dmd') return model === 'cabinato' || model === 'oldstyle';
    return compatibility(item);
  };

  const groupEls = {};
  root.querySelectorAll('[data-group]').forEach(el => {
    groupEls[el.dataset.group] = el;
  });

  function esc(s) {
    return String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  }

  function money(cents) {
    return moneyFmt.format((Number(cents) || 0) / 100);
  }

  const isQuantityItem = h => ['volante-20cm','kit-guida-analogico','lightgun-senza-recoil-fondina','lightgun-con-recoil'].includes(h);
  const isLightgun = h => h === 'lightgun-senza-recoil-fondina' || h === 'lightgun-con-recoil';

  function card(item, index) {
    const quantityMode = isQuantityItem(item.h);
    const lightgun = isLightgun(item.h);
    const selected = state.selected.has(item.h);
    const quantity = state.quantities.get(item.h) || 0;
    const price = state.prices.get(item.h);
    const priceText = price != null ? money(price) : (Number(item.p) === 0 ? 'GRATIS' : money(Number(item.p) * 100));
    const otherLightgunHandle = item.h === 'lightgun-senza-recoil-fondina' ? 'lightgun-con-recoil' : (item.h === 'lightgun-con-recoil' ? 'lightgun-senza-recoil-fondina' : '');
    const otherLightgunQty = lightgun ? (state.quantities.get(otherLightgunHandle) || 0) : 0;
    const maxQty = lightgun ? Math.max(0, 2 - otherLightgunQty) : 3;
    const colorSelection = lightgun ? (state.lightgunColors.get(item.h) || []) : [];
    const colors = lightgun ? ['Rossa','Blu','Grigia','Nera'] : [];
    const colorHtml = lightgun && quantity > 0 ? `<div class="drg-color-picker"><span>Colore${quantity > 1 ? ' (max 2)' : ''}</span><div class="drg-color-options">${colors.map(c => `<button type="button" class="drg-color-dot ${colorSelection.includes(c)?'is-active':''}" data-lightgun-color="${esc(c)}" data-lightgun-handle="${esc(item.h)}" aria-label="${esc(c)}" title="${esc(c)}"><span></span></button>`).join('')}</div><strong class="drg-color-name">${esc(colorSelection.length ? colorSelection.join(' + ') : 'Scegli il colore')}</strong><small class="drg-color-help">Un solo colore = tutte uguali. Due colori = una per colore.</small></div>` : '';
    const placeholder = item.g === 'connectivity' ? 'WI-FI' : 'DMD';
    const img = item.i
      ? `<img loading="lazy" data-drg-image-handle="${esc(item.h)}" src="${esc(item.i)}" alt="${esc(item.t)}">`
      : `<div class="drg-no-image"><span>${placeholder}</span></div>`;
    const recommended = item.rec ? `<span class="drg-badge">SCELTA CONSIGLIATA</span>` : '';
    return `
      <article class="drg-card ${selected ? 'is-selected' : ''}" data-handle="${esc(item.h)}" data-group="${esc(item.g)}">
        <div class="drg-card-media">${img}</div>
        <div class="drg-card-body">
          ${recommended}
          <div class="drg-card-title-row">
            <h4>${esc(item.t)}</h4>
          </div>
          <div class="drg-card-description">
            ${item.di && item.h !== 'wifi-extreme' && item.h !== 'marquee-dinamico-led-hd-dmd-p320' ? `<img class="drg-description-image" loading="lazy" src="${esc(item.di)}" alt="${esc(item.t)}">` : ''}
            <p>${esc(item.d)}</p>
          </div>
          ${item.game ? `<div class="drg-card-games"><strong>Compatibile con:</strong> ${esc(item.game)}</div>` : ''}
          ${colorHtml}
          <div class="drg-card-bottom">
            <strong>${priceText}${quantityMode ? ` <small>/ cad. · max ${maxQty}</small>` : ''}</strong>
            ${quantityMode ? `<div class="drg-qty" data-qty-handle="${esc(item.h)}"><button type="button" class="drg-qty-btn" data-qty="minus" aria-label="Diminuisci quantità">−</button><strong>${quantity}</strong><button type="button" class="drg-qty-btn" data-qty="plus" data-max="${maxQty || ''}" aria-label="Aumenta quantità">+</button></div>` : `<button type="button" class="drg-select">${selected ? 'SELEZIONATO ✓' : 'SELEZIONA'}</button>`}
          </div>
        </div>
      </article>`;
  }

  function renderGroup(group) {
    const el = groupEls[group];
    if (!el) return;
    const items = accessories.filter(x => x.g === group && isCompatible(x) && x.h !== 'secondo-kit-guida-analogico' && x.h !== 'terzo-kit-guida-analogico');
    if (!items.length) {
      el.closest('.drg-step')?.classList.add('drg-step-empty');
      el.innerHTML = '';
      return;
    }
    el.closest('.drg-step')?.classList.remove('drg-step-empty');
    el.innerHTML = items.map(card).join('');
  }

  function hydrateBrokenImages() {
    root.querySelectorAll('img[data-drg-image-handle]').forEach(img => {
      if (img.dataset.drgBound === '1') return;
      img.dataset.drgBound = '1';
      img.addEventListener('error', async () => {
        const handle = img.dataset.drgImageHandle;
        try {
          const p = await fetchProduct(handle);
          const fallback = (p.images || [])[0];
          if (fallback && img.src !== fallback) {
            img.src = fallback;
            return;
          }
        } catch (e) {}
        img.closest('.drg-card-media')?.classList.add('drg-image-failed');
      }, { once: true });
    });
  }

  function renderAll() {
    ['controls','arcade','shooter','driving','steeringwheel','video','hardware_disk','hardware','connectivity','audio','extra','dmd'].forEach(renderGroup);
    updateLinkedVisibility();
    updateSummary();
    hydrateBrokenImages();
  }

  function totalGuideKits() {
    return (state.quantities.get('volante-20cm') || 0) + (state.quantities.get('kit-guida-analogico') || 0);
  }

  function selectedDrivingKit() {
    return totalGuideKits() > 0;
  }

  function updateLinkedVisibility() {
    const linked = root.querySelector('[data-linked="steeringwheel"]');
    if (!linked) return;
    linked.classList.toggle('is-visible', selectedDrivingKit());
    if (!selectedDrivingKit() && state.selected.has('volante-30cm')) {
      state.selected.delete('volante-30cm');
    }
  }

  function selectionMode(item) {
    if (item.g === 'controls' || item.g === 'shooter' || item.g === 'video' || item.g === 'hardware_disk') return 'single';
    if (item.g === 'driving') return 'single';
    if (item.g === 'driving_extra') return 'multi';
    if (item.g === 'steeringwheel') return 'single';
    if (item.g === 'extra') return 'single';
    if (item.g === 'dmd') return 'multi';
    return 'multi';
  }

  function select(item) {
    const quantityMode = isQuantityItem(item.h);
    const lightgun = isLightgun(item.h);
    if (quantityMode) {
      const current = state.quantities.get(item.h) || 0;
      if (current > 0) { state.quantities.delete(item.h); state.selected.delete(item.h); }
      else { state.quantities.set(item.h, 1); state.selected.set(item.h, item); }
      renderAll();
      return;
    }
    const mode = selectionMode(item);
    if (state.selected.has(item.h)) {
      state.selected.delete(item.h);
    } else {
      if (mode === 'single') {
        const group = item.g;
        accessories.filter(x => x.g === group).forEach(x => state.selected.delete(x.h));
      }
      state.selected.set(item.h, item);
    }
    if (item.g === 'driving' && !selectedDrivingKit()) state.selected.delete('volante-30cm');
    renderAll();
  }

  async function fetchProduct(handle) {
    if (state.products.has(handle)) return state.products.get(handle);
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Prodotto non disponibile: ${handle}`);
    const p = await res.json();
    state.products.set(handle, p);
    const variant = (p.variants || []).find(v => v.available) || (p.variants || [])[0];
    if (variant) state.prices.set(handle, Number(variant.price));
    return p;
  }

  async function preloadPrices() {
    const visible = accessories.filter(isCompatible);
    await Promise.allSettled(visible.map(x => fetchProduct(x.h)));
    renderAll();
  }

  function updateSummary() {
    const list = root.querySelector('.drg-summary-list');
    const totalEl = root.querySelector('.drg-total-price');
    const addTotal = root.querySelector('.drg-add-total');
    const addBtn = root.querySelector('.drg-add');
    const count = root.querySelector('.drg-summary-count');
    const graphicEl = root.querySelector('.drg-summary-graphic-value');

    let total = state.basePrice;
    let extras = 0;
    const rows = [];

    state.selected.forEach((item, handle) => {
      const price = state.prices.get(handle);
      const cents = price != null ? price : Number(item.p || 0) * 100;
      const qty = isQuantityItem(handle) ? (state.quantities.get(handle) || 1) : 1;
      total += cents * qty;
      extras += qty;
      const colorSelection = isLightgun(handle) ? (state.lightgunColors.get(handle) || []) : [];
      const colorLabel = isLightgun(handle) ? ` · ${colorSelection.length ? colorSelection.join(' + ') : 'colore da scegliere'}` : '';
      rows.push(`<div class="drg-summary-row"><span>${esc(item.t)}${qty > 1 ? ` × ${qty}` : ''}${esc(colorLabel)}</span><strong>${cents === 0 ? 'GRATIS' : money(cents * qty)}</strong></div>`);
    });

    list.innerHTML = rows.length ? rows.join('') : '<div class="drg-empty">Nessun optional selezionato</div>';
    totalEl.textContent = money(total);
    addTotal.textContent = money(total);
    count.textContent = `${extras} ${extras === 1 ? 'extra' : 'extra'}`;
    if (graphicEl) graphicEl.textContent = state.graphic || 'Da definire';
    addBtn.disabled = state.busy;
    root.querySelector('.drg-summary').style.setProperty('--drg-total', `${total}`);
  }


  function updateProgress() {
    const steps = [...root.querySelectorAll('.drg-step:not(.drg-step-empty)')];
    const vh = window.innerHeight || 800;
    let current = 1;
    let best = 0;
    steps.forEach((s, i) => {
      const rect = s.getBoundingClientRect();
      if (rect.top < vh * 0.42 && rect.bottom > vh * 0.20) current = i + 1;
      if (rect.top < vh * 0.55) best = i + 1;
    });
    const pct = Math.min(100, Math.max(0, (best / Math.max(steps.length,1)) * 100));
    root.querySelector('.drg-progress-bar span').style.width = `${pct}%`;
    root.querySelector('.drg-progress-current').textContent = String(Math.max(1,current)).padStart(2,'0');
  }

  async function addToCart() {
    if (state.busy) return;
    state.busy = true;
    const btn = root.querySelector('.drg-add');
    const old = btn.querySelector('.drg-add-label').textContent;
    btn.querySelector('.drg-add-label').textContent = 'AGGIUNTA IN CORSO…';
    btn.disabled = true;

    try {
      const graphicInput = root.querySelector('.drg-graphic-input');
      if (graphicInput) state.graphic = graphicInput.value.trim();
      const selected = [...state.selected.values()];
      const missingLightgunColor = selected.find(x => {
        const colors = state.lightgunColors.get(x.h) || [];
        const qty = state.quantities.get(x.h) || 0;
        return isLightgun(x.h) && (!colors.length || (qty > 1 && colors.length > 2));
      });
      if (missingLightgunColor) {
        throw new Error(`Scegli il colore per ${missingLightgunColor.t}.`);
      }
      const fetched = await Promise.all(selected.map(x => fetchProduct(x.h)));

      const items = [{
        id: productVariantId,
        quantity: 1,
        properties: {
          'Configuratore DRG': 'Sì',
          'Grafica': state.graphic || 'Da definire',
          'Optional selezionati': selected.length ? selected.map(x => { const q = (x.h === 'volante-20cm' || x.h === 'kit-guida-analogico') ? (state.quantities.get(x.h) || 1) : 1; return q > 1 ? `${x.t} x${q}` : x.t; }).join(', ') : 'Nessuno'
        }
      }];

      selected.forEach((item, idx) => {
        const p = fetched[idx];
        const variant = (p.variants || []).find(v => v.available) || (p.variants || [])[0];
        if (!variant) throw new Error(`Nessuna variante disponibile per ${item.t}`);
        const qty = isQuantityItem(item.h) ? (state.quantities.get(item.h) || 1) : 1;
        items.push({
          id: variant.id,
          quantity: qty,
          properties: {
            'Configurazione': productTitle,
            'Configuratore DRG': 'Sì',
            'Quantità kit': String(qty),
            ...(isLightgun(item.h) ? {'Colore LightGun': (() => { const c = state.lightgunColors.get(item.h) || []; return c.length === 1 ? `${c[0]} x${qty}` : c.join(' + '); })()} : {}),
            'Gruppo': item.g === 'hardware_disk' ? 'Hardware - Archiviazione' : item.g
          }
        });
      });

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items})
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Impossibile aggiungere la configurazione al carrello.');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.location.href = '/cart';
    } catch (err) {
      console.error(err);
      alert(err.message || 'Si è verificato un errore. Riprova.');
      btn.querySelector('.drg-add-label').textContent = old;
      state.busy = false;
      btn.disabled = false;
    }
  }

  root.addEventListener('click', async e => {
    const colorBtn = e.target.closest('[data-lightgun-color]');
    if (colorBtn) {
      e.preventDefault();
      const handle = colorBtn.dataset.lightgunHandle;
      const item = accessories.find(x => x.h === handle);
      if (item && isLightgun(handle) && (state.quantities.get(handle) || 0) > 0) {
        const qty = state.quantities.get(handle) || 1;
        const color = colorBtn.dataset.lightgunColor;
        const current = [...(state.lightgunColors.get(handle) || [])];
        const index = current.indexOf(color);
        if (index >= 0) {
          current.splice(index, 1);
        } else {
          if (qty === 1) current.length = 0;
          if (current.length >= Math.min(qty, 2)) current.shift();
          current.push(color);
        }
        state.lightgunColors.set(handle, current);
        state.selected.set(handle, item);
        renderAll();
      }
      return;
    }

    const qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      e.preventDefault();
      const handle = qtyBtn.closest('[data-qty-handle]')?.dataset.qtyHandle;
      const item = accessories.find(x => x.h === handle);
      if (item) {
        let qty = state.quantities.get(handle) || 0;
        let max = Infinity;
        if (isLightgun(handle)) {
          const other = handle === 'lightgun-senza-recoil-fondina' ? 'lightgun-con-recoil' : 'lightgun-senza-recoil-fondina';
          max = Math.max(0, 2 - (state.quantities.get(other) || 0));
        }
        else if (handle === 'volante-20cm' || handle === 'kit-guida-analogico') { const otherKitQty = totalGuideKits() - qty; max = Math.max(0, 3 - otherKitQty); }
        qty += qtyBtn.dataset.qty === 'plus' ? 1 : -1;
        qty = Math.max(0, Math.min(max, qty));
        if (qty <= 0) {
          state.quantities.delete(handle);
          state.selected.delete(handle);
          if (isLightgun(handle)) state.lightgunColors.delete(handle);
        } else {
          state.quantities.set(handle, qty);
          state.selected.set(handle, item);
        }
        renderAll();
      }
      return;
    }

    const selectBtn = e.target.closest('.drg-select');
    if (selectBtn) {
      const c = selectBtn.closest('.drg-card');
      const item = accessories.find(x => x.h === c.dataset.handle);
      if (item) select(item);
      return;
    }

    const add = e.target.closest('.drg-add');
    if (add) { await addToCart(); return; }
  });

  const graphicInput = root.querySelector('.drg-graphic-input');
  const syncGraphic = e => {
    state.graphic = e.target.value.trim();
    const summaryGraphic = root.querySelector('.drg-summary-graphic-value');
    if (summaryGraphic) summaryGraphic.textContent = state.graphic || 'Da definire';
  };
  graphicInput?.addEventListener('input', syncGraphic);
  graphicInput?.addEventListener('change', syncGraphic);

  window.addEventListener('scroll', updateProgress, {passive:true});

    if (!Number.isNaN(runtimeBasePrice) && runtimeBasePrice > 0) state.basePrice = runtimeBasePrice;
    if (!state.basePrice) {
      const moneyMeta = document.querySelector('meta[property="product:price:amount"]');
      if (moneyMeta) {
        const euro = parseFloat(moneyMeta.content);
        if (!Number.isNaN(euro)) state.basePrice = Math.round(euro * 100);
      }
    }
    if (!state.basePrice) {
      const fallback = root.querySelector('.drg-base-price')?.textContent || '';
      const n = parseFloat(fallback.replace(/[^\d,.-]/g,'').replace('.','').replace(',','.'));
      state.basePrice = Number.isNaN(n) ? 0 : Math.round(n*100);
    }
    root.querySelectorAll('[data-drg-runtime-title]').forEach(el => el.textContent = productTitle);
    root.querySelectorAll('[data-drg-runtime-price]').forEach(el => el.textContent = money(state.basePrice));
    const modelImageWrap = root.querySelector('[data-drg-summary-model-image]');
    const modelImage = root.querySelector('[data-drg-runtime-image]');
    if (modelImageWrap && modelImage) {
      if (runtimeImage) {
        modelImage.src = runtimeImage;
        modelImage.alt = productTitle;
        modelImageWrap.hidden = false;
      } else {
        modelImageWrap.hidden = true;
      }
    }
    renderAll();
    preloadPrices();
    updateProgress();
    return true;
  }

  // Expose the initializer immediately, even on the selector page where no product is selected yet.
  window.DRGStartConfigurator = startConfigurator;
  if (root && root.dataset.pageMode !== 'selector') startConfigurator(root, null);
})();
